export enum Messages {
  ERROR_FORMAT = 'Le format n\'est pas valide.',
  ERROR_FORMAT_WEIGHT = 'Le contenant a un poids nul. Il ne peut être intégré à l\'expédition',
  ERROR_TARE = 'Le poids renseigné est inférieur à la tare.',
  ERROR_WEIGHT_EQUAL_ZERO = 'Le poids du conteneur doit être strictement supérieur à 0.',
  ERROR_VALUE = 'La valeur n\'est pas valide.',
  ERROR_CONSIGNMENT_CONTENT_CONSTANT = 'contenant',
  ERROR_CONSIGNMENT_CONTENT_TRB_CONSTANT = 'contenant transbord',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_ADDED = 'Le n° contenant flashé a déjà été ajouté.',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_EXIST ='Le contenant flashé est déjà présent dans l\'expédition.',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_ASSOCIATED_ROUTE ='Le contenant est déjà associé au trajet. ',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_ASSOCIATED_CONSIGNMENT ='Le contenant est déjà associé à une expédition.',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_ASSOCIATED_CONSIGNMENT_ALL_DEPECHE ='L’association de la dépêche n’est pas autorisée pour ce contenant.',
  ERROR_RECEPTACLE_TRANSPORT_NOT_AVAILABLE = 'La catégorie de transport de la dépêche n\'est pas adaptée.',
  ERROR_DESPATCH_ALREADY_ADDED = 'La dépêche a déjà été ajoutée.',
  ERROR_DESPATCH_ALREADY_ASSOCIATED = 'Toute la dépêche est déjà associée à une expédition.',
  ERROR_DESPATCH_STILL_OPENED = 'La dépêche est encore ouverte.',
  ERROR_CALL_WS = 'Le serveur renvoie le message suivant : {0}',
  ERROR_SERVER = 'Le serveur a rencontré un problème technique, merci de réessayer plus tard.',
  ERROR_DESPATCH_NOT_FROM_DZ = 'Le contenant flashé n\'est pas créé sur DZ.',
  ERROR_BAD_FORMAT = 'Le cab flashé est vide ou le format est invalide.',
  ERROR_DELETED = 'Ce contenant est supprimé.',
  ERROR_EXPO_AUTO_MOBILE = 'Le n° n\'est pas un n° d\'expédition auto',
  ERROR_EXPO_AUTO_DESKTOP = 'Le n° d\'expédition n\'est pas un n° d\'expédition auto.',
  ERROR_DECOMMISION = `Le conteneur n° {0} n'a pas été désaffecté.`,
  ERROR_DECOMMISION_FLIGHT = `Le contenu du vol {0} n'a pas été désaffecté.`,
  ERROR_REASSIGN = `Le conteneur numéro {0} n'a pas été réaffecté.`,
  ERROR_REASSIGN_FLIGHT = `Le vol numéro {0} n'a pas été réaffecté.`,
  ERROR_ASSIGN = `Le conteneur numéro {0} n'a pas été affecté.`,
  ERROR_CONTAINER_ALREADY_USED = 'Ce numéro de conteneur est déjà utilisé.',
  ERROR_TRANSFERT_CONTAINER = 'Le transfert du contenu a échoué.',
  ERROR_UPDATE_CONTAINER_WEIGHT = 'Le changement de poids du conteneur a échoué.',
  ERROR_SEND_CONTAINER_HLRC_OUTDATED = 'La HLRC du vol associé est atteinte',
  ERROR_CANCEL_MANUAL_EXPEDITION = 'L\'expédition {0} n\'a pas été annulée.',
  ERROR_REASSIGN_CONSIGNMENT = `L'expédition {0} n'a pas pu être réaffectée au trajet souhaité. Veuillez réessayer.`,
  ETAT_REQUIRED_ERROR = `Veuillez sélectionner au moins 1 état {0}.`,
  ERROR_END_BEFORE_START= `La date de fin ne peut pas être antérieure à la date de début.`,
  ERROR_DATE_PERIOD_TOO_BIG = `La période de recherche ne peut pas excéder 7 jours.`,
  ERROR_FORMAT_CAB_29 = 'Format invalide. Format attendu : 29 caractères.',
  ERROR_FORMAT_NUMERO_EXPEDITION = 'Format invalide. Exemple : FRCDG3500026',
  SUCCESS_SAVE_TRAJET = 'Le contenu du trajet a été mis à jour.',
  AIRPORT_FIELD_FORMAT_ERROR = 'Veuillez sélectionner un aéroport valide. Exemple : ADANA.',
  IMPC_FIELD_VALUE_ERROR = 'Veuillez sélectionner un IMPC valide. Exemple : ROCOAF.',
  PORT_FIELD_FORMAT_ERROR = 'Veuillez sélectionner un port valide. Exemple : BEBRU - BRUSSELS',
  COUNTRY_FIELD_VALUE_ERROR = 'Veuillez sélectionner un pays de destination valide. Exemple : AD - Andorra.',
  INVALID_DATE_FORMAT_ERROR = 'Format de date invalide.',
  UNAUTHORIZED_DATE_ERROR  = 'Date non autorisé.',
  INCORRECT_DATE_ERROR  = 'Date incorrect.',
  INVALID_HOUR_FORMAT_ERROR = 'Veuillez saisir une heure de départ. Format attendu : HH:MM.',
  PORT_FIELD_VALUE_ERROR = 'Veuillez sélectionner un port valide. Exemple : FRCDG.',
  TRANSPORTER_FIELD_VALUE_ERROR = 'Format invalide. Exemple : BT - AIR BALTIC.',
  PERIOD_FIELD_FORMAT_ERROR = 'La période n\'est pas conforme.',
  FLIGHT_NUMBER_INVALID_ERROR = 'Le numéro de vol est inconnu.',
  ERROR_PAYS = 'Veuillez sélectionner un pays.',
  CAT_FIELD_VALUE_ERROR = 'Veuillez sélectionner une catégorie valide. Exemple : A,B,C ou D.',
  TRANSBORD_FIELD_VALUE_ERROR = 'Veuillez sélectionner \'oui\' ou \'non\'.',
  CLASS_FIELD_VALUE_ERROR = 'Veuillez sélectionner une classe valide. Exemple : U,C,E ou T.',
  SUBCLASS_FIELD_VALUE_ERROR = 'Veuillez sélectionner une classe/sous-classe valide. Exemple : UN.',
  ASSOCIATION_AIRPORT_HAS_FLIGHT_NUMBER_INVALID = 'L\'association avec le n° de vol n\'existe pas.',
  ASSOCIATION_FLIGHT_NUMBER_HAS_AIRPORT_INVALID = 'L\'association avec l\'aéroport n\'existe pas.',
  REQUIRED_FIELDS_INFO  = 'Les champs marqués d’une * sont obligatoires.',
  INFO_VALIDATE_ROUTING = 'L\'expédition n°{0} a été fermée avec succès.',
  INFO_SEND_CONTAINER = 'Le conteneur {0} et ses {1} expéditions ont été fermés.',
  INFO_DECOMMISION = `Le conteneur n° {0} a été désaffecté avec succès.`,
  INFO_DECOMMISION_FLIGHT = 'Le contenu du vol {0} a bien été désaffecté.',
  UNLOAD_CONTAINER_SORTING_TCA_ERROR = 'Le conteneur {0} n\'a pas été débarqué.',
  INFO_UNLOAD_CONTAINER = 'Le conteneur {0} a bien été débarqué du vol {1} et réaffecté au vol {2}.',
  INFO_REASSIGN_CONTAINER = 'Le conteneur numéro {0} a été réaffecté avec succès à destination de {1}.',
  INFO_REASSIGN_FLIGHT = 'Le contenu du vol {0} a bien été réaffecté au vol {1}.',
  INFO_REASSIGN_CONSIGNMENT = 'L\'expédition {0} a été affectée à un nouveau trajet avec succès.',
  INFO_ASSIGN_CONTAINER = 'Le conteneur numéro {0} a bien été affecté au vol {1}.',
  UNLOAD_CONTAINER_SORTING_TCA = 'Voulez-vous débarquez le conteneur {0} pour tri TCA? Cette action entaînera l\'annulation de l\'expédition initiale.',
  DELETE_CONTAINER = 'Voulez-vous supprimer le conteneur {0} ?',
  UNLOAD_CONTAINER_SORTING_TCA_SUCESS = 'Le conteneur {0} a bien été débarqué.',
  DELETE_CONTAINER_SUCESS = 'Le conteneur {0} a bien été supprimé.',
  DELETE_CONTAINER_ERROR = 'Le conteneur {0} n\'a pas été supprimé.',
  INFO_COMPLETE_FLIGHT = 'Le vol {0} a bien été finalisé.',
  INFO_AFFECT = 'Le vol {0} a bien été affecté à la sortie {1}.',
  INFO_UNAFFECT = ' Le vol {0} a bien été désaffecté de la sortie {1}.',
  EXTRACT_CSV = 'L\'extraction est en cours, merci de patienter.',
  TRANSFERT_CONTAINER = 'Renseignez le numéro du conteneur où tous les contenants du conteneur d\'origine ({0}) seront transférés',
  INFO_TRANSFERT_CONTAINER = 'Le contenu a bien été transféré du conteneur {0} au conteneur {1}.',
  INFO_UPDATE_CONTAINER_WEIGHT = 'Le poids total du conteneur {0} a bien été modifié.',
  INFO_ADD_CONTENT_CONTAINER = 'Le cab {0} a bien été ajouté au conteneur {1}.',
  CONTENT_ALREADY_ADD_FOR_DELETED = 'Le contenant a déjà été flashé.',
  INFO_DELETE_ALL_CONTENT_CONTENEUR = 'Tous les contenants du conteneur {0} ont bien été supprimés.',
  INFO_DELETE_ONE_CONTENT_CONTENEUR = 'Le contenant {0} a bien été supprimé.',
  INFO_DELETE_CONTENT_CONTENEUR = 'Les {0} contenants ont bien été supprimés.',
  RECEPTACLE_EXIST = 'Ce contenant fait déjà partie de la liste ci-dessous',
  MSG_UNLOAD_CONSIGNMENT_CONTENTS = 'Les contenants ont bien été débarqués.',
  VERIFICATION_SEND_CONTAINER = 'Le conteneur peut être expédié.',
  INFO_CANCEL_MANUAL_EXPEDITION = 'L\'expédition a été annulée avec succès',
  MESSAGE_TOASTER_FINALIZE_ROUTE = 'Le trajet n°{0} a été finalisé avec succès.',
  MESSAGE_TOASTER_GENERATE_QR_CODE = 'Le QR Code a été généré avec succès.',
  MESSAGE_SCAN_QR_CODE = 'Veuillez scanner <br> le QR Code <br> du trajet à traiter',
  ERROR_RECEPTACLE_TIMEOUT_EXCEPTION = 'Le trajet n°{0} du {1} à {2} n\'est plus disponible. Vous ne pouvez pas ajouter de nouveaux contenants.',
  ERROR_CONSIGNMENT_ROUTE_TIMEOUT_EXCEPTION = 'Le trajet n°{0} du {1} à {2} n\'est plus disponible. Vous ne pouvez pas fermer l\'expédition.',
  ERROR_CONSIGNMENT_ROUTING_INVALID_EXCEPTION = "Le trajet n°{0} du {1} à {2} ne correspond à aucun acheminement valide. Impossible de finaliser l'expédition, veuillez rafraîchir la page.",
  ERROR_RECEPTACLE_ROUTE_COMPLETED_EXCEPTION = 'Le trajet n°{0} du {1} à {2} est déjà finalisé. Vous ne pouvez pas ajouter de nouveaux contenants.',
  ERROR_RECEPTACLE_ROUTE_NOT_FOUND_EXCEPTION = 'Le trajet n\'est plus disponible. Veuillez renouveler votre recherche.',
  INFO_DELETE_CONTENTS_TRAJET = 'Les contenants ont été supprimés du trajet avec succès.',
  ROUTE_ERROR = 'Erreur sur le trajet {0}',
  ROUTE_NOT_FOUND_ERROR = 'Le trajet recherché n\'est plus <br/> disponible.',
  RENEW_SEARCH_ERROR = 'Veuillez regénérer le QR Code <br/> depuis un poste fixe.',
  TIMEOUT_ROUTE_ERROR = 'Délai dépassé : le trajet n°{0} <br/> du {1} à {2} <br/> n\'est plus disponible.',
  COMPLETED_ROUTE_ERROR = 'Le trajet n°{0} du {1} <br/> à {2} est déjà finalisé.',
  CANT_ADD_CONSIGNMENT_ERROR = 'Vous ne pouvez pas ajouter de <br/> nouveaux contenants.',
  MESSAGE_TOASTER_ADD_CONTENT_MOBILE_ERROR = 'Les contenants n\'ont pas été ajoutés au trajet, veuillez réessayer.',
  MESSAGE_TOASTER_ADD_CONTENT_MOBILE_SUCCESS = 'Les contenants ont été ajoutés au trajet avec succès.',
  ADD_CONTENT_MOBILE_ERROR = 'Ce contenant n\'est pas compatible avec l\'acheminement séléctionné. <BR/><BR/><B> Il a été retiré de la sélection.</B>',
  ERROR_CONSIGNMENT_CONTENT_FORMAT_MOBILE = '<B> Le format du code à barres flashé n\'est pas valide. </B>',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_EXIST_MOBILE = 'Le contenant <br/> n°{0} <br/> est déjà associé à une expédition. <br/> <br/> <B> Il a été retiré de la sélection. </B>',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_EXIST_MOBILE_ALL_DEPECHE = 'L\'association de la dépêche n’est pas <br/> autorisée pour ce contenant n°{0}',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_ASSOCIATED_ROUTE_MOBILE ='Le contenant n° <br/>{0} <br/> est déjà associé au trajet.',
  CONSIGNMENT_CONTENT_ALREADY_ADDED_TO_LIST = 'Le contenant flashé a déjà été ajouté',
  TRY_AGAIN = 'Veuillez réessayer',
  ERROR_CONSIGNMENT_CONTENT_CONSISTENCY = 'Le contenant scanné n\'est pas compatible avec l\'acheminement sélectionné.<br> Il a été retiré de la sélection.',
  ERROR_CONSISTENCY_TRB = 'sélectionné. Les contenants Transbord ne sont pas autorisés sur les trajets route.<br>',
  ERROR_CONSISTENCY = 'sélectionné.<br>',
  ERROR_CONSIGNMENT_CONTENT_CONSISTENCY_INVALID_PERIODICITY = 'L\'ajout de ce contenant n\'est pas autorisé à la date du trajet sélectionné.<br> Il a été retiré de la sélection.',
  ERROR_CONSIGNMENT_CONTENT_CONSISTENCY_INVALID_PERIODICITY_MOBILE = 'L\'ajout de ce contenant n\'est pas autorisé à la date du trajet sélectionné.<br><B> Il a été retiré de la sélection.</B>',
  ERROR_RECEPTACLE_FORMAT_EXCEPTION = 'Le contenant {0} est mal formaté',
}

export enum Titles {
  HOME = 'Accueil - Expédition Export',
  SORTIE_VOL = 'Association Sortie Vol - Expédition Export',
  EXPEDITION_MANUELLE = 'Recherche Expédition manuelle - Expédition',
  EXPEDITION_AUTO = 'Recherche Expédition Flux TCA - Expédition',
  RECHERCHE_EXP = 'Rechercher des expéditions - Expédition',
  DEFAULT_TITLE = 'Expédition - Export',
  RECHERCHE_CONTENANTS = 'Recherche de contenants - Expédition Export',

  INFO_VALIDATION_ROUTING = 'Expédition fermée',
  INFO_SEND_CONTAINER = 'Conteneur expédié',
  INFO_DECOMMISION = 'Désaffectation avec succès',
  INFO_DECOMMISION_FLIGHT = 'Succès de la désaffectation',
  INFO_UNLOAD = 'Succès du débarquement',
  INFO_REASSIGN_CONTAINER = 'Réaffectation avec succès',
  INFO_REASSIGN_FLIGHT = 'Succès de la réaffectation',
  INFO_REASSIGN_CONSIGNMENT = 'Expédition réaffectée',
  INFO_ASSIGN_CONTAINER = 'Succès de l\'affectation',
  INFO_COMPLETE_FLIGHT = 'Finalisation effectuée',
  INFO_AFFECT = 'Succès de l\'affectation',
  INFO_UNAFFECT = 'Succès de la désaffectation',
  INFO_CANCEL_MANUAL_EXPEDITION = 'Expédition annulée',
  EXTRACT_CSV = 'Extraction Csv',
  EXTRACT_EXCEL = 'Extraction Excel',

  ERROR_CALL_WS = 'Erreur serveur',
  ERROR_VALIDATION_ROUTING = 'Erreur validation de l\'expédition',
  ERROR_SEND_CONTAINER = 'Erreur expédition du conteneur',
  ERROR_DECOMMISION = 'Échec de la désaffectation',
  ERROR_DECOMMISSION_FLIGHT = 'Erreur lors de la désaffectation',
  ERROR_REASSIGN = 'Échec de la réaffectation',
  ERROR_REASSIGN_CONSIGNMENT = 'Erreur de réaffectation',
  ERROR_ASSIGN = 'Échec de l\'affectation',
  ERROR_COMPLETE_FLIGHT = 'Erreur finalisation vol',
  ERROR_CANCEL_MANUAL_EXPEDITION = 'Erreur lors de l\'annulation de l\'expédition',
  UNLOAD_CONTAINER_SORTING_TCA_SUCESS = 'Succès du débarquement',
  UNLOAD_CONTAINER_SORTING_TCA_ERROR = 'Échec du débarquement',
  DELETE_CONTAINER_SUCESS = 'Succès de la suppression',
  DELETE_CONTAINER_ERROR = 'Échec de la suppression',
  CLASS_SUBCLASS = 'Voir les classes / sous-classes',
  TRANSFERT_CONTAINER_ERROR = 'Erreur lors du transfert de contenu',
  TRANSFERT_CONTAINER_SUCESS = 'Succès du transfert de contenu',
  UPDATE_CONTAINER_WEIGHT_SUCCESS = 'Succès modification du poids',
  ERROR_FIND_DESPATCH = 'Erreur lors de la récupération des dépêches',
  ERROR_FIND_CONSIGNMENT = 'Erreur lors de la récupération des expéditions',
  ADD_CONTENT_CONTAINER_ERROR = 'Erreur lors de l\'ajout du cab',
  ADD_CONTENT_CONTAINER_SUCESS = 'Succès lors de l\'ajout du cab',
  UPDATE_CONTAINER_WEIGHT_ERROR = 'Erreur modification du poids',
  DELETE_CONSIGNMENT_CONTENT_CONTAINER_ERROR = 'Erreur lors de la suppression du cab',
  UNLOAD_CONSIGNMENT_CONTENTS = 'Contenants débarqués',
  VERIFICATION_SEND_CONTAINER = 'Vérification OK',
  TITLE_TOASTER_FINALIZE_ROUTE = 'Trajet finalisé',
  TITLE_TOASTER_GENERATE_QR_CODE = 'QR Code généré',
  ERROR_ROUTE_NOT_FOUND = 'Trajet indisponible',
  ERROR_ROUTE_TIMEOUT = 'Trajet n°{0}: délai dépassé',
  ERROR_ROUTE_COMPLETED = 'Trajet n°{0} déjà finalisé',
  ERROR_ROUTE_INVALID = 'Trajet n°{0} non valide',
  DELETE_CONSIGNMENT_CONTENTS_TRAJET_SUCCESS = 'Contenant(s) supprimé(s)',
  TITLE_TOASTER_ADD_CONTENT_MOBILE_ERROR = 'Erreur ajout contenants',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_EXIST_MOBILE = 'Contenant déjà associé à une expédtion',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_EXIST_MOBILE_ALL_DEPECHE = 'Ajout de la dépêche impossible',
  ERROR_CONSIGNMENT_CONTENT_ALREADY_ASSOCIATED_ROUTE_MOBILE = 'Contenant déjà associé au trajet',
  ERROR_DUPLICATED= 'Une erreur est survenue lors {0}',
  ERROR_DUPLICATE_CONSIGNMENT_ACTION='de l\'expédition',
  ERROR_DUPLICATE_REASSIGN_ACTION='de la réaffectation',
  ERROR_DUPLICATE_CONTAINER_ACTION='de l\'expédition du conteneur',
  ERROR_DUPLICATE_ADD_IN_CONTAINER_ACTION='Une erreur est survenue lors de l\'ajout du cab',
  ERROR_DUPLICATE_UNLOAD_CONTAINER_ACTION='du débarquement du conteneur',
  ERROR_CONSIGNMENT_CONTENT_CONSISTENCY = 'Ajout du contenant impossible',
 }

export enum Chevron {
  ADD_CONTENT = 'Ajouter le contenant',
  SEND_CONTAINER = 'Expédier le conteneur',
  VERIFY_CONTAINER = 'Vérifier le conteneur',
  DECOMMISSION_CONTAINER_VOL = 'Désaffecter le conteneur du vol',
  REASSIGN_CONTAINER_VOL = 'Réaffecter le conteneur à un vol',
  ASSIGN_CONTAINER_VOL = 'Affecter le conteneur à un vol',
  UNLOAD_CONTAINER_SORTING_TCA = 'Débarquer le conteneur pour tri TCA',
  UNLOAD_CONTAINER = 'Débarquer le conteneur',
  DELETE_CONTAINER = 'Supprimer le conteneur',
  COMPLETE_FLIGHT = 'Finaliser le vol',
  TRANSFERT_CONTAINER = 'Transférer le contenu du conteneur',
  DECOMMISSION_FLIGHT = 'Désaffecter le vol',
  REASSIGN_FLIGHT = 'Réaffecter le vol',
  CHANGE_GROSS_WEIGHT = 'Modifier le poids brut',
  DELETE_CONSIGNMENT_CONTENTS_CONTAINER = 'Supprimer contenant(s)',
  CLOSE_ROUTE = 'Finaliser le trajet',
  ADD_CONTENTS = 'Ajouter des contenants',
  DELETE_CONTENTS = 'Supprimer des contenants',
  GENERATE_QRCODE = 'Générer un QR Code',
  VALIDATE_EXP = 'Expédier',
  CANCEL_EXP = 'Annuler l\'expédition',
  REASSIGN_EXP = 'Réaffecter à un trajet',
  REEDIT_DOCUMENTS = 'Rééditer les documents',
  REEDIT_FINALIZATION_DOCUMENT = "Rééditer la fiche de finalisation"
}

export enum Picto {
  PAIRED = 'En cours de remplissage',
  UNPAIRED = 'Désappairé TCA',
  RELEASED_TCA = 'Désappairé TCA',
  GIVEN_CARRIER = 'Remis au transporteur',
  FINALIZED = 'Fermé (Expédié)',
  OVERHANG = 'Débord',
  DOUBLING = 'Dédoublement'
}

export enum PopinTitle {
  UNLOAD = 'Débarquer le conteneur',
  DELETE = 'Supprimer le conteneur',
  REASSIGN = 'Réaffecter le conteneur à un vol',
  ASSIGN = 'Affecter le conteneur à un vol',
  UNLOAD_CONTAINER_SORTING_TCA = 'Débarquer le conteneur pour tri TCA',
  AFFECT = 'Affecter la sortie {0} à un vol',
  UNAFFECT = 'Désaffecter le vol {0} de la sortie TCA ?',
  TRANSFERT = 'Transférer le contenu du conteneur',
  ADD_CONTENT = 'Ajout de contenants non flashés pour départ export avion',
  ADD_CONTENT_VALIDATION = 'Ajout de contenants non flashés pour départ export avion',
  TITLE_ADD_SUBTITLE = 'Contenant(s) ajouté(s)',
  REASSIGN_FLIGHT = 'Réaffecter le vol',
  CHANGE_GROSS_WEIGHT = 'Modifier le poids brut',
  TITLE_DELETE_SUBTITLE = 'Contenant(s) à supprimer',
  DELETE_CONSIGNMENT_CONTENTS_CONTAINER = 'Suppression contenant(s) du conteneur',
  DELETE_CONSIGNMENT_CONTENTS_CONTAINER_VALIDATION = 'Valider la suppression',
  IMPOSSIBLE_TO_SEND_CONTAINER = 'Expédition du conteneur impossible',
  CONSIGNMENT_CONTENTS_TO_UNLOAD = 'Contenant(s) à débarquer',
  CONTAINER_OR_FLIGHT_CHANGED = 'Changement de statut détecté',
  TITLE_DESAFFECTER = "Désaffecter le conteneur du vol",
  TITLE_DECOMMISSION_FLIGHT = 'Désaffecter le vol',
  DELETE_UNLOAD_RECEPTACLE = 'Quitter sans supprimer',
  FINALISER_LE_TRAJET = "Finaliser le trajet n°",
  TITLE_CANCEL_MANUAL_EXPEDITION = 'Annuler l\'expédition',
  DELETE_CONSIGNMENT_CONTENTS_TRAJET = 'Suppression contenant(s) du trajet',
  REASSIGN_CONSIGNMENT = 'Réaffecter l\'expédition {0} à un trajet',
  TITLE_MOBILE_ADD_CONTENT_QUITTER = 'Êtes-vous sûr(e) de vouloir quitter ?',
  CONSIGNMENT_CONTENT_ERROR_TITLE = 'Certains contenants ne peuvent être associés au trajet',
  ALL_CONSIGNMENT_CONTENT_ERROR_TITLE = 'Les contenants ne peuvent être associés au trajet',
  IMPOSSIBLE_TO_SEND_CONSIGNMENT = 'Expédition impossible',
}

export enum PopinMessage {
  UNLOAD = 'Choisissez le vol de réaffectation',
  REASSIGN = 'Choisissez le nouveau vol à affecter :',
  AFFECT = 'Choisissez le vol à affecter :',
  CHANGE_GROSS_WEIGHT = 'Vous pouvez renseigner le poids brut du conteneur {0} \nci-dessous.',
  DELETE_CONSIGNMENT_CONTENTS_CONTAINER_VALIDATION = 'Êtes vous sûr de vouloir supprimer les contenants ? Cette action est irréversible.',
  CAB_NOT_SECURED_VALIDATED = 'Certains contenants posent problème:',
  MESSAGE_DESAFFECTER = "Voulez-vous désaffecter le conteneur {0} du vol {1}? Cette action entraînera l'annulation de l'expédition",
  ADD_CONTENT_VALIDATION = 'Validez-vous l\'ajout de contenant(s) au conteneur {0} ? Cette action entraînera l\'annulation de l\'expédition initiale',
  UNLOAD_VALIDATION = "Voulez-vous débarquer le conteneur {0}? Cette action entraînera l'annulation de l'expédition initiale",
  DECOMMISSION_FLIGHT = "Voulez-vous désaffecter le vol {0}? Cette action entraînera l'annulation de l'expédition pour tous les conteneurs associés.",
  REASSIGN_FLIGHT = "Voulez-vous réaffecter le vol {0}? Cette action entraînera l'annulation de l'expédition pour tous les conteneurs associés.",
  CONTAINER_OR_FLIGHT_CHANGED = "Le {0} a changé de statut, nous allons actualiser les informations du tableau",
  MESSAGE_VALID_UNLOAD_RECEPTACLE = "Êtes vous sûr de vouloir supprimer les contenants associés aux conteneurs dans la liste ? <br/> Cette action est irréversible : elle entraine la modification des expéditions concernées.",
  MESSAGE_RETURN_UNLOAD_RECEPTACLE = "Êtes-vous sûr de vouloir quitter ? <br/> Vos modifications ne seront pas prises en compte.",
  MESSAGE_CANCEL_MANUAL_EXPEDITION = `Êtes-vous sûr de vouloir annuler l'expédition {0} ? <br/> Cette action est irréversible.`,
  REASSIGN_CONSIGNMENT = 'Choisissez le nouveau trajet à affecter :',
  MESSAGE_MOBILE_ADD_CONTENT_QUITTER = "Cette action entrainera <b>la suppression définitive des contenants déjà flashés dans la liste</b>.",
  CONSIGNMENT_CONTENT_ERROR_MSG =  '{0} contenants sur {1} ont déjà été traités,',
  CONSIGNMENT_CONTENT_ERROR_SUB_MSG = ' ils ont été retirés de la sélection :',
  ERROR_SOME_CONSIGNMENT_CONTENT_NOT_TO_BE_ASSOCIATED_ROUTE = '{0} contenants sur {1} sont déjà associés à une expédition. <br/> <b> Ils ont été retirés de la sélection. </b>',
  ERROR_ALL_CONSIGNMENT_CONTENT_NOT_TO_BE_ASSOCIATED_ROUTE = 'L\'ensemble des contenants de la dépêches {0} sont déjà associés à une expédition. <br/> <b> Ils ont été retirés de la sélection. </b>',
  DUPLICATED_CAB_MESSAGE = "Vous devez débarquer le(s) contenant(s) suivant(s) pour pouvoir expédier le conteneur : ",
  IMPOSSIBLE_TO_SEND_CONSIGNMENT = "Le contenant {0} est supprimé de Dépêche Export",
  CONTAINER_NUMBER_SPECIAL_CHAR = "Le nom du conteneur {0} contient un caractère spécial, il ne peut être expédié."
}

export enum File {
  PREFIX_ASSOCIATION_CSV = 'extraction_association-',
  PREFIX_RECHERCHE_EXPEDITION = 'extraction_recherche_expedition-',
  PREFIX_PRODUCTION_PLAN_CSV = 'Extraction-conteneurs-moins-de-72h-',
  PREFIX_SORTING_CSV = 'extraction_sortings',
  SUFFIX_CSV = '.csv',
  PREFIX_UNLOAD_RECEPTACLE = 'receptacles_unboarding',
  PREFIX_CONSIGNMENT_CONTENTS_CSV = 'extraction_consignment_contents_'
}

export enum Pattern {
  DATE_CSV = 'DD-MM-yyyy-HH:mm:ss'
}

export enum PopinFlightHeaderLibelle {
  flight = 'N° de vol',
  route = 'N° de trajet',
  aeroport = 'Aéroport',
  destination = 'Destination'
}

export enum RegexPattern {
  IMPC_REGEX = '^[a-zA-Z]{0,6}$'
}

export const PARTIAL_DATE_REGEX = /^$|^\d{1,2}$|^\d{1,2}\/$|^\d{1,2}\/\d{1,2}$|^\d{1,2}\/\d{1,2}\/$|^\d{1,2}\/\d{1,2}\/\d{1,4}$/;

export const FINAL_DATE_REGEX = /^(?:0[1-9]|[12]\d|3[01])\/(?:0[1-9]|1[0-2])\/(?:19|20)\d{2}$/;

export const PARTIAL_TIME_REGEX: RegExp = /^$|^\d{1,2}$|^\d{1,2}:$|^\d{1,2}:\d{1,2}$/;

export const FINAL_TIME_REGEX: RegExp = /^(?:[01]\d|2[0-3]):[0-5]\d$/;


export const TO_BE_GENERATED_LATER: string = 'TO_BE_GENERATED_LATER';

export const ERROR_MESSAGE_FROM_BACK_NO_TRANSPORT_FOUND: string = '[FlightsService][getFlightByIdAndTransportType] No transport found for id';

export const CONTENT_TYPE_HEADER: string = 'Content-Type';
